import { isSeoCityMarket } from './isSeoCityMarket';

interface SeoVenue {
  accessType?: string | null;
  addressString?: string | null;
  amenities?: readonly unknown[] | null;
  city?: { latitude?: number | string | null; longitude?: number | string | null } | null;
  courtSurfaces?: readonly unknown[] | null;
  email?: string | null;
  hasPadel?: boolean | null;
  hasPickleball?: boolean | null;
  hasReservations?: boolean | null;
  hasTennis?: boolean | null;
  images?: readonly unknown[] | null;
  indoorCourtCount?: number | null;
  latitude?: number | string | null;
  longitude?: number | string | null;
  outdoorCourtCount?: number | null;
  phoneNumber?: string | null;
  pickleballNets?: string | null;
  scheduleDetails?: string | null;
  slug?: string | null;
  title?: string | null;
  websiteUrl?: string | null;
}

const MIN_VENUE_SEO_SIGNALS = 2;
const NEEDS_AUDIT_ACCESS_TYPE = 'NEEDS_AUDIT';

const hasText = (value?: string | null) => !!value?.trim();
const hasItems = (value?: readonly unknown[] | null) => Array.isArray(value) && value.length > 0;
const getNumber = (value?: number | string | null) => {
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : 0;
};

const getVenueSeoSignalCount = (venue: SeoVenue) => {
  const totalCourtCount = getNumber(venue.indoorCourtCount) + getNumber(venue.outdoorCourtCount);

  return [
    hasText(venue.addressString),
    totalCourtCount > 0,
    hasItems(venue.images),
    hasItems(venue.amenities),
    hasItems(venue.courtSurfaces),
    hasText(venue.email) || hasText(venue.phoneNumber) || hasText(venue.websiteUrl),
    hasText(venue.accessType) && venue.accessType !== NEEDS_AUDIT_ACCESS_TYPE,
    hasText(venue.pickleballNets),
    hasText(venue.scheduleDetails),
    !!venue.hasReservations,
  ].filter(Boolean).length;
};

export const isIndexableVenueForSeo = (venue?: SeoVenue | null) => {
  if (!venue) {
    return false;
  }

  const isInSeoMarket = isSeoCityMarket(venue.city) || isSeoCityMarket(venue);
  const hasSport = !!venue.hasPickleball || !!venue.hasTennis || !!venue.hasPadel;

  return (
    isInSeoMarket &&
    hasText(venue.title) &&
    hasText(venue.slug) &&
    hasSport &&
    getVenueSeoSignalCount(venue) >= MIN_VENUE_SEO_SIGNALS
  );
};
